module.exports = __webpack_public_path__ + "static/card-organize-do-4788d20408fe6492078f9cab02fda7f3.png";